import { API } from "@/lib/api";


const size = (t, w) => {
  const m = (cm) => ((Number(cm) || 0) / 100 / (Number(w) || 20)) * 100;
  if (t.forma === "rotondo") { const d = m(t.diametro || 180); return [d, d]; }
  if (t.forma === "quadrato") { const d = m(t.lunghezza || t.diametro || 120); return [d, d]; }
  return [m(t.lunghezza || 240), m(t.larghezza || 100)];
};

function AiLayer({ plan, picks, draft }) {
  if (plan.analisi?.mask) return <><img src={`${API}/floorplans/${plan.id}/mask?v=${plan.analisi.mask.at}`} alt="" className="absolute inset-0 w-full h-full pointer-events-none" data-testid="map-ai-mask" /><AiMarks plan={plan} picks={picks} draft={draft} noArea /></>;
  return <AiMarks plan={plan} picks={picks} draft={draft} />;
}

function AiMarks({ plan, picks, draft, noArea }) {
  const a = plan.analisi;
  const k = (plan.img_w || 1) / (plan.img_h || 1);
  const W = Number(plan.larghezza_m) || 20;
  const s = plan.scala;
  return (
    <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none" data-testid="map-ai-layer">
      {!noArea && a?.area?.length > 2 && <polygon points={a.area.map((p) => p.join(",")).join(" ")} fill="rgba(52,179,176,0.12)" stroke="#34B3B0" strokeWidth="2" strokeDasharray="6 4" vectorEffect="non-scaling-stroke" />}
      {(plan.vietate || []).map((z, i) => <polygon key={`v${i}`} points={z.map((p) => p.join(",")).join(" ")} fill="rgba(185,28,28,0.28)" stroke="#B91C1C" strokeWidth="2" vectorEffect="non-scaling-stroke" data-testid={`map-banned-${i}`} />)}
      {draft?.length > 0 && <polyline points={[...draft, ...(draft.length > 2 ? [draft[0]] : [])].map((p) => p.join(",")).join(" ")} fill={draft.length > 2 ? "rgba(185,28,28,0.18)" : "none"} stroke="#B91C1C" strokeWidth="2" strokeDasharray="5 3" vectorEffect="non-scaling-stroke" />}
      {draft?.map((p, i) => <ellipse key={`d${i}`} cx={p[0]} cy={p[1]} rx="0.7" ry={0.7 * k} fill="#B91C1C" />)}
      {a?.ostacoli?.map((o, i) => <ellipse key={i} cx={o.x} cy={o.y} rx={(o.r_m / W) * 100} ry={(o.r_m / W) * 100 * k} fill="rgba(224,122,95,0.35)" stroke="#E07A5F" strokeWidth="1" vectorEffect="non-scaling-stroke" />)}
      {s && <line x1={s.x1} y1={s.y1} x2={s.x2} y2={s.y2} stroke="#F59E0B" strokeWidth="4" vectorEffect="non-scaling-stroke" />}
      {picks?.map((p, i) => <ellipse key={i} cx={p[0]} cy={p[1]} rx="0.8" ry={0.8 * k} fill="#E07A5F" />)}
      {picks?.length === 2 && <line x1={picks[0][0]} y1={picks[0][1]} x2={picks[1][0]} y2={picks[1][1]} stroke="#E07A5F" strokeWidth="3" vectorEffect="non-scaling-stroke" />}
    </svg>
  );
}

export function FloorMap({ plan, src, tables, used, highlight, selected, onTablePointerDown, onTableClick, onBgPointerMove, onBgPointerUp, mapRef, testId = "floor-map", showAi, picks, draft, onMapClick }) {
  const click = (e) => {
    if (!onMapClick) return;
    const r = e.currentTarget.getBoundingClientRect();
    onMapClick([Math.round(((e.clientX - r.left) / r.width) * 10000) / 100, Math.round(((e.clientY - r.top) / r.height) * 10000) / 100]);
  };
  return (
    <div ref={mapRef} className={`relative w-full select-none touch-none rounded-xl overflow-hidden border border-[#D4E6EC] bg-white ${onMapClick ? "cursor-crosshair" : ""}`} onClick={click} onPointerMove={onBgPointerMove} onPointerUp={onBgPointerUp} onPointerLeave={onBgPointerUp} data-testid={testId}>
      <img src={src} alt={plan.nome} className="w-full block pointer-events-none" draggable={false} />
      {showAi && <AiLayer plan={plan} picks={picks} draft={draft} />}
      {tables.map((t) => {
        const [w, h] = size(t, plan.larghezza_m);
        const off = used && !used.has(t.id);
        const hl = highlight === t.id;
        return (
          <div key={t.id} onPointerDown={onTablePointerDown ? (e) => onTablePointerDown(e, t) : undefined} onClick={onTableClick ? () => onTableClick(t) : undefined}
            className={`absolute flex items-center justify-center text-white font-semibold shadow-md transition-[background-color,box-shadow,opacity] ${t.forma === "rotondo" || t.forma === "ovale" ? "rounded-full" : "rounded-md"} ${off ? "bg-[#94A3B8]/50 opacity-60" : t.sposi ? "bg-[#C9A96A]" : "bg-[#0B6E8F]/90"} ${hl ? "ring-4 ring-[#E07A5F]/60 ring-offset-2 z-20 !bg-[#E07A5F] scale-125 shadow-[0_0_0_10px_rgba(224,122,95,0.25)]" : ""} ${selected === t.id ? "ring-4 ring-[#0D2B3A] z-10" : ""} ${onTablePointerDown || onTableClick ? "cursor-pointer" : ""}`}
            style={{ left: `${t.x}%`, top: `${t.y}%`, width: `${w}%`, aspectRatio: `${w} / ${h}`, transform: `translate(-50%, -50%) rotate(${t.rot || 0}deg)`, fontSize: "clamp(9px, 1.4vw, 15px)" }}
            data-testid={`map-table-${t.numero || t.id}`}>
            <span style={{ transform: `rotate(${-(t.rot || 0)}deg)` }}>{t.sposi && !t.numero ? "♥" : t.numero || "?"}</span>
          </div>
        );
      })}
    </div>
  );
}

export const tableLabel = (t) => (t.sposi && !String(t.numero || "").trim() ? "Tavolo sposi" : `Tavolo ${String(t.numero || "").trim() || "?"}`);
